export enum ModelVisibility {
    Anyone = "Anyone",
    AuthenticxOnly = "AuthenticxOnly",
    SpecificRoles = "SpecificRoles",
}

export enum ClassifierAccessType {
    View = 1,
}
